<!--
  - Copyright (c) 2019 brightlamp
  -->

<template>
    <div :id="elementId">
        <v-row>
            <v-col cols="12" sm="6" md="3" lg="2" xl="2">
                <v-expansion-panels accordion multiple v-model="panelNormalized">
                    <v-expansion-panel>
                        <v-expansion-panel-header style="color: #ffffff; background-color: #b71c1c; font-size: 15px">Normalized Range
                            <template v-slot:actions>
                                <v-icon slot="actions" color="#ffffff">$vuetify.icons.expand</v-icon>
                            </template>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <v-list dense class="mx-n6">
                                <v-list-item>
                                    <v-list-item-content>Amplitude</v-list-item-content>
                                    <v-list-item-content class="align-end">{{tableData.allNormalizedData[9].minNormalData ? `${tableData.allNormalizedData[9].minNormalData} - ${tableData.allNormalizedData[9].maxNormalData} mm` : 'N/A'}}</v-list-item-content>
                                </v-list-item>
                                <v-list-item v-if="resultType !== 'No Light'">
                                    <v-list-item-content>Avg. Constriction Speed</v-list-item-content>
                                    <v-list-item-content class="align-end">{{tableData.allNormalizedData[0].minNormalData ? `${tableData.allNormalizedData[0].minNormalData} - ${tableData.allNormalizedData[0].maxNormalData} mm/sec` : 'N/A'}}</v-list-item-content>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-content>Avg. Diameter</v-list-item-content>
                                    <v-list-item-content class="align-end">{{tableData.allNormalizedData[1].minNormalData ? `${tableData.allNormalizedData[1].minNormalData} - ${tableData.allNormalizedData[1].maxNormalData} mm` : 'N/A'}}</v-list-item-content>
                                </v-list-item>
                                <v-list-item v-if="resultType !== 'Constrict' && resultType !== 'No Light'">
                                    <v-list-item-content>Avg. Dilation Velocity</v-list-item-content>
                                    <v-list-item-content class="align-end">{{tableData.allNormalizedData[2].minNormalData ? `${tableData.allNormalizedData[2].minNormalData} - ${tableData.allNormalizedData[2].maxNormalData} mm/sec` : 'N/A'}}</v-list-item-content>
                                </v-list-item>
                                <v-list-item v-if="resultType !== 'No Light'">
                                    <v-list-item-content>Constriction Time</v-list-item-content>
                                    <v-list-item-content class="align-end">{{tableData.allNormalizedData[3].minNormalData ? `${tableData.allNormalizedData[3].minNormalData} - ${tableData.allNormalizedData[3].maxNormalData} mm` : 'N/A'}}</v-list-item-content>
                                </v-list-item>
                                <v-list-item v-if="resultType !== 'No Light'">
                                    <v-list-item-content>Latency</v-list-item-content>
                                    <v-list-item-content class="align-end">{{tableData.allNormalizedData[4].minNormalData ? `${tableData.allNormalizedData[4].minNormalData} - ${tableData.allNormalizedData[4].maxNormalData} sec` : 'N/A'}}</v-list-item-content>
                                </v-list-item>
                                <v-list-item v-if="resultType !== 'No Light'">
                                    <v-list-item-content>Max. Constriction Speed</v-list-item-content>
                                    <v-list-item-content class="align-end">{{tableData.allNormalizedData[5].minNormalData ? `${tableData.allNormalizedData[5].minNormalData} - ${tableData.allNormalizedData[5].maxNormalData} mm/sec` : 'N/A'}}</v-list-item-content>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-content>Max. Diameter</v-list-item-content>
                                    <v-list-item-content class="align-end">{{tableData.allNormalizedData[6].minNormalData ? `${tableData.allNormalizedData[6].minNormalData} - ${tableData.allNormalizedData[6].maxNormalData} mm` : 'N/A'}}</v-list-item-content>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-content>Min. Diameter</v-list-item-content>
                                    <v-list-item-content class="align-end">{{tableData.allNormalizedData[7].minNormalData ? `${tableData.allNormalizedData[7].minNormalData} - ${tableData.allNormalizedData[7].maxNormalData} mm` : 'N/A'}}</v-list-item-content>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-content>Release Amplitude</v-list-item-content>
                                    <v-list-item-content class="align-end">{{tableData.allNormalizedData[10].minNormalData ? `${tableData.allNormalizedData[10].minNormalData} - ${tableData.allNormalizedData[10].maxNormalData} mm` : 'N/A'}}</v-list-item-content>
                                </v-list-item>
                                <v-list-item v-if="resultType !== 'Constrict' && resultType !== 'No Light'">
                                    <v-list-item-content>75% Recovery Time</v-list-item-content>
                                    <v-list-item-content class="align-end">{{tableData.allNormalizedData[8].minNormalData ? `${tableData.allNormalizedData[8].minNormalData} - ${tableData.allNormalizedData[8].maxNormalData} sec` : 'N/A'}}</v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-col>
            <v-col v-if="tableData.rightBaseline" cols="12" sm="6" md="3" lg="2" xl="2">
                <v-expansion-panels accordion multiple v-model="panelRightBaseline">
                    <v-expansion-panel>
                        <v-expansion-panel-header style="color: #ffffff; background-color: #0d47a1; font-size: 15px">{{`(R) Baseline ${tableData.rightBaseline.visitDate}`}}
                            <template v-slot:actions>
                                <v-icon slot="actions" color="#ffffff">$vuetify.icons.expand</v-icon>
                            </template>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <v-list dense class="mx-n6">
                                <v-list-item>
                                    <v-list-item-content>Amplitude</v-list-item-content>
                                    <v-list-item-content class="align-end">{{tableData.rightBaseline.amp ? `${tableData.rightBaseline.amp} mm` : 'N/A'}}</v-list-item-content>
                                </v-list-item>
                                <v-list-item v-if="resultType !== 'No Light'">
                                    <v-list-item-content>Avg. Constriction Speed</v-list-item-content>
                                    <v-list-item-content class="align-end">{{tableData.rightBaseline.avgConSpd ? `${tableData.rightBaseline.avgConSpd} mm/sec` : 'N/A'}}</v-list-item-content>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-content>Avg. Diameter</v-list-item-content>
                                    <v-list-item-content class="align-end">{{tableData.rightBaseline.avgDiamtr ? `${tableData.rightBaseline.avgDiamtr} mm` : 'N/A'}}</v-list-item-content>
                                </v-list-item>
                                <v-list-item v-if="resultType !== 'Constrict' && resultType !== 'No Light'">
                                    <v-list-item-content>Avg. Dilation Velocity</v-list-item-content>
                                    <v-list-item-content class="align-end">{{tableData.rightBaseline.dilationVel ? `${tableData.rightBaseline.dilationVel} mm/sec` : 'N/A'}}</v-list-item-content>
                                </v-list-item>
                                <v-list-item v-if="resultType !== 'No Light'">
                                    <v-list-item-content>Constriction Time</v-list-item-content>
                                    <v-list-item-content class="align-end">{{tableData.rightBaseline.timeToMnDiamtr ? `${tableData.rightBaseline.timeToMnDiamtr} mm` : 'N/A'}}</v-list-item-content>
                                </v-list-item>
                                <v-list-item v-if="resultType !== 'No Light'">
                                    <v-list-item-content>Latency</v-list-item-content>
                                    <v-list-item-content class="align-end">{{tableData.rightBaseline.latncy ? `${tableData.rightBaseline.latncy} sec` : 'N/A'}}</v-list-item-content>
                                </v-list-item>
                                <v-list-item v-if="resultType !== 'No Light'">
                                    <v-list-item-content>Max. Constriction Speed</v-list-item-content>
                                    <v-list-item-content class="align-end">{{tableData.rightBaseline.mxConSpd ? `${tableData.rightBaseline.mxConSpd} mm/sec` : 'N/A'}}</v-list-item-content>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-content>Max. Diameter</v-list-item-content>
                                    <v-list-item-content class="align-end">{{tableData.rightBaseline.mxDiamtr ? `${tableData.rightBaseline.mxDiamtr} mm` : 'N/A'}}</v-list-item-content>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-content>Min. Diameter</v-list-item-content>
                                    <v-list-item-content class="align-end">{{tableData.rightBaseline.mnDiamtr ? `${tableData.rightBaseline.mnDiamtr} mm` : 'N/A'}}</v-list-item-content>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-content>Release Amplitude</v-list-item-content>
                                    <v-list-item-content class="align-end">{{tableData.rightBaseline.ramp ? `${tableData.rightBaseline.ramp} mm` : 'N/A'}}</v-list-item-content>
                                </v-list-item>
                                <v-list-item v-if="resultType !== 'Constrict' && resultType !== 'No Light'">
                                    <v-list-item-content>75% Recovery Time</v-list-item-content>
                                    <v-list-item-content class="align-end">{{tableData.rightBaseline.recTime75 ? `${tableData.rightBaseline.recTime75} sec` : 'N/A'}}</v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-col>
            <v-col v-if="tableData.leftBaseline" cols="12" sm="6" md="3" lg="2" xl="2">
                <v-expansion-panels accordion multiple v-model="panelLeftBaseline">
                    <v-expansion-panel>
                        <v-expansion-panel-header style="color: #ffffff; background-color: #7c4dff; font-size: 15px">{{`(L) Baseline ${tableData.leftBaseline.visitDate}`}}
                            <template v-slot:actions>
                                <v-icon slot="actions" color="#ffffff">$vuetify.icons.expand</v-icon>
                            </template>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <v-list dense class="mx-n6">
                                <v-list-item>
                                    <v-list-item-content>Amplitude</v-list-item-content>
                                    <v-list-item-content class="align-end">{{tableData.leftBaseline.amp ? `${tableData.leftBaseline.amp} mm` : 'N/A'}}</v-list-item-content>
                                </v-list-item>
                                <v-list-item v-if="resultType !== 'No Light'">
                                    <v-list-item-content>Avg. Constriction Speed</v-list-item-content>
                                    <v-list-item-content class="align-end">{{tableData.leftBaseline.avgConSpd ? `${tableData.leftBaseline.avgConSpd} mm/sec` : 'N/A'}}</v-list-item-content>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-content>Avg. Diameter</v-list-item-content>
                                    <v-list-item-content class="align-end">{{tableData.leftBaseline.avgDiamtr ? `${tableData.leftBaseline.avgDiamtr} mm` : 'N/A'}}</v-list-item-content>
                                </v-list-item>
                                <v-list-item v-if="resultType !== 'Constrict' && resultType !== 'No Light'">
                                    <v-list-item-content>Avg. Dilation Velocity</v-list-item-content>
                                    <v-list-item-content class="align-end">{{tableData.leftBaseline.dilationVel ? `${tableData.leftBaseline.dilationVel} mm/sec` : 'N/A'}}</v-list-item-content>
                                </v-list-item>
                                <v-list-item v-if="resultType !== 'No Light'">
                                    <v-list-item-content>Constriction Time</v-list-item-content>
                                    <v-list-item-content class="align-end">{{tableData.leftBaseline.timeToMnDiamtr ? `${tableData.leftBaseline.timeToMnDiamtr} mm` : 'N/A'}}</v-list-item-content>
                                </v-list-item>
                                <v-list-item v-if="resultType !== 'No Light'">
                                    <v-list-item-content>Latency</v-list-item-content>
                                    <v-list-item-content class="align-end">{{tableData.leftBaseline.latncy ? `${tableData.leftBaseline.latncy} sec` : 'N/A'}}</v-list-item-content>
                                </v-list-item>
                                <v-list-item v-if="resultType !== 'No Light'">
                                    <v-list-item-content>Max. Constriction Speed</v-list-item-content>
                                    <v-list-item-content class="align-end">{{tableData.leftBaseline.mxConSpd ? `${tableData.leftBaseline.mxConSpd} mm/sec` : 'N/A'}}</v-list-item-content>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-content>Max. Diameter</v-list-item-content>
                                    <v-list-item-content class="align-end">{{tableData.leftBaseline.mxDiamtr ? `${tableData.leftBaseline.mxDiamtr} mm` : 'N/A'}}</v-list-item-content>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-content>Min. Diameter</v-list-item-content>
                                    <v-list-item-content class="align-end">{{tableData.leftBaseline.mnDiamtr ? `${tableData.leftBaseline.mnDiamtr} mm` : 'N/A'}}</v-list-item-content>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-content>Release Amplitude</v-list-item-content>
                                    <v-list-item-content class="align-end">{{tableData.leftBaseline.ramp ? `${tableData.leftBaseline.ramp} mm` : 'N/A'}}</v-list-item-content>
                                </v-list-item>
                                <v-list-item v-if="resultType !== 'Constrict' && resultType !== 'No Light'">
                                    <v-list-item-content>75% Recovery Time</v-list-item-content>
                                    <v-list-item-content class="align-end">{{tableData.leftBaseline.recTime75 ? `${tableData.leftBaseline.recTime75} sec` : 'N/A'}}</v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-col>
            <template v-for="(item, index) in tableData.items">
                <v-col cols="12" sm="6" md="3" lg="2" xl="2">
                    <v-expansion-panels accordion multiple v-model="panelTests[index]">
                        <v-expansion-panel>
                            <v-expansion-panel-header :style="`color: #ffffff; background-color: ${item.rightEye ? '#ff6d00' : '#1b5e20'}; font-size: 15px`">{{`${item.rightEye ? '(R)' : '(L)'} ${item.visitDate}`}}
                                <template v-slot:actions>
                                   <v-icon slot="actions" color="#ffffff">$vuetify.icons.expand</v-icon>
                                </template>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <v-list dense class="mx-n6">
                                    <v-list-item>
                                        <v-list-item-content>Amplitude</v-list-item-content>
                                        <v-list-item-content class="align-end">{{item.amp ? `${item.amp} mm` : 'N/A'}}</v-list-item-content>
                                    </v-list-item>
                                    <v-list-item v-if="resultType !== 'No Light'">
                                        <v-list-item-content>Avg. Constriction Speed</v-list-item-content>
                                        <v-list-item-content class="align-end">{{item.avgConSpd ? `${item.avgConSpd} mm/sec` : 'N/A'}}</v-list-item-content>
                                    </v-list-item>
                                    <v-list-item>
                                        <v-list-item-content>Avg. Diameter</v-list-item-content>
                                        <v-list-item-content class="align-end">{{item.avgDiamtr ? `${item.avgDiamtr} mm` : 'N/A'}}</v-list-item-content>
                                    </v-list-item>
                                    <v-list-item v-if="resultType !== 'Constrict' && resultType !== 'No Light'">
                                        <v-list-item-content>Avg. Dilation Velocity</v-list-item-content>
                                        <v-list-item-content class="align-end">{{item.dilationVel ? `${item.dilationVel} mm/sec` : 'N/A'}}</v-list-item-content>
                                    </v-list-item>
                                    <v-list-item v-if="resultType !== 'No Light'">
                                        <v-list-item-content>Constriction Time</v-list-item-content>
                                        <v-list-item-content class="align-end">{{item.timeToMnDiamtr ? `${item.timeToMnDiamtr} mm` : 'N/A'}}</v-list-item-content>
                                    </v-list-item>
                                    <v-list-item v-if="resultType !== 'No Light'">
                                        <v-list-item-content>Latency</v-list-item-content>
                                        <v-list-item-content class="align-end">{{item.latncy ? `${item.latncy} sec` : 'N/A'}}</v-list-item-content>
                                    </v-list-item>
                                    <v-list-item v-if="resultType !== 'No Light'">
                                        <v-list-item-content>Max. Constriction Speed</v-list-item-content>
                                        <v-list-item-content class="align-end">{{item.mxConSpd ? `${item.mxConSpd} mm/sec` : 'N/A'}}</v-list-item-content>
                                    </v-list-item>
                                    <v-list-item>
                                        <v-list-item-content>Max. Diameter</v-list-item-content>
                                        <v-list-item-content class="align-end">{{item.mxDiamtr ? `${item.mxDiamtr} mm` : 'N/A'}}</v-list-item-content>
                                    </v-list-item>
                                    <v-list-item>
                                        <v-list-item-content>Min. Diameter</v-list-item-content>
                                        <v-list-item-content class="align-end">{{item.mnDiamtr ? `${item.mnDiamtr} mm` : 'N/A'}}</v-list-item-content>
                                    </v-list-item>
                                    <v-list-item>
                                        <v-list-item-content>Release Amplitude</v-list-item-content>
                                        <v-list-item-content class="align-end">{{item.ramp ? `${item.ramp} mm` : 'N/A'}}</v-list-item-content>
                                    </v-list-item>
                                    <v-list-item v-if="resultType !== 'Constrict' && resultType !== 'No Light'">
                                        <v-list-item-content>75% Recovery Time</v-list-item-content>
                                        <v-list-item-content class="align-end">{{item.recTime75 ? `${item.recTime75} sec` : 'N/A'}}</v-list-item-content>
                                    </v-list-item>
                                </v-list>
                             </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </template>
        </v-row>
    </div>
</template>

<script>
    export default
    {
        name: 'trending-data-table',
        data: function ()
        {
            return {
                panelNormalized: [],
                panelRightBaseline: [],
                panelLeftBaseline: [],
                panelTests: []
            }
        },
        props:
        {
            showExpanded: false,
            resultType: '',
            tableData: {},
            elementId: ''
        },
        watch:
        {
            tableData()
            {
                if (this.showExpanded)
                {
                    this.expand()
                }
                else
                {
                    this.collapse()
                }
            }
        },
        mounted()
        {
            if (this.showExpanded)
            {
                this.expand()
            }
            else
            {
                this.collapse()
            }
        },
        methods:
        {
            expand()
            {
                this.panelNormalized = [0];
                this.panelRightBaseline = [0];
                this.panelLeftBaseline = [0];
                for (let index = 0; index < this.tableData.items.length; ++index)
                {
                    this.panelTests[index] = [0]
                }
            },
            collapse()
            {
                this.panelNormalized = [];
                this.panelRightBaseline = [];
                this.panelLeftBaseline = [];
                this.panelTests = []
            }
        }
    }
</script>

<style scoped>
</style>